export default __webpack_public_path__ + "static/media/button-right-arrow.81dfd695.svg";